import {uri} from '@/api/uri/base.js'
import Toast from '@/utils/toast'
import {calPrice} from '@/utils/calc.js'
import {
  getRequest,
  postJsonRequest,
  putJsonRequest,
  deleteRequest,
} from '@/utils/api'

/*
*   检查福祉卡是否具有权限
* */
export function checkCard(cardNo) {
  return new Promise((resolve, reject) => {
    getRequest(uri.setting.checkCard + cardNo).then(resp => {
      resolve(resp.data)
    }).catch(error => {
      // Toast.show({
      //   message: error || '查询福祉卡失败',
      //   type: 'error'
      // })
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/base/setting.js